import React from 'react';
import { TableContainer, Table, TableBody, TableRow, TableCell } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../resources/strings/StringKeys';

const AvailabilityTable = ({ availability }) => {
    const { t } = useTranslation();
    const weekDaysOrder = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

    const formatTimeToAMPM = (hour) => {
        const hourNum = parseInt(hour);
        if (hourNum === 12) return "12:00 PM";
        if (hourNum === 0) return "12:00 AM";
        return hourNum > 12 
            ? `${hourNum - 12}:00 PM` 
            : `${hourNum}:00 AM`;
    };

    return (
        <TableContainer>
            <Table aria-label="availability-table">
                <TableBody>
                    {weekDaysOrder.map((day) => {
                        const dayAvailability = availability[day];
                        return (
                            <TableRow key={day}>
                                <TableCell component="th" scope="row">
                                    {day}
                                </TableCell>
                                <TableCell>
                                    {dayAvailability.restrictions === 'limited' ? (
                                        <>
                                            {t(StringKeys.LIMITED)}
                                            {dayAvailability.available_times.map((time, index) => (
                                                <div key={index}>
                                                    {t(StringKeys.START)}: {formatTimeToAMPM(time.from)} {t(StringKeys.END)}: {formatTimeToAMPM(time.to)}
                                                </div>
                                            ))}
                                        </>
                                    ) : dayAvailability.restrictions === 'unavailable' ? (
                                        t(StringKeys.UNAVAILABLE)
                                    ) : (
                                        t(StringKeys.AVAILABLE)
                                    )}
                                </TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default AvailabilityTable; 